import { createUseStyles } from 'react-jss'

import { colors } from 'components/common/colors'

const useListStyles = createUseStyles({
  list: {
    border: `1px solid ${colors.gray200}`,
    overflow: 'hidden',
    borderRadius: '4px',
    margin: '0.5rem 0',

    '&.disabled': {
      opacity: 0.4,
      pointerEvents: 'none'
    }
  }
})

const useListItemStyles = createUseStyles({
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    userSelect: 'none',
    backgroundColor: '#fff',

    '&:not(:last-child)': {
      borderBottom: `1px solid ${colors.gray100}`
    },

    '&:hover': {
      backgroundColor: '#fff9cc'
    },
    '&:hover > .list-item-actions': {
      display: 'flex'
    }
  },
  listItemContent: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '1rem',
    padding: '0.5rem 0',
    maxWidth: '60%',

    '& > p': {
      margin: '0.25rem 0',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  },
  listItemActions: {
    display: 'none',
    margin: '0 0.5rem'
  }
})

export { useListItemStyles, useListStyles }
